import { render, staticRenderFns } from "./TransferMemberInputModal.vue?vue&type=template&id=1cc38650&lang=pug"
import script from "./TransferMemberInputModal.vue?vue&type=script&lang=ts"
export * from "./TransferMemberInputModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports